module.exports = __webpack_public_path__ + "img/content12.7a7bf598.png";